import { clamp, fbm, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createVeil(): DrawFn {
  const rng = mulberry32(56)
  const stars = Array.from({ length: 70 }, () => ({
    x: rng(),
    y: rng(),
    s: 0.4 + rng() * 1.5,
    o: rng() * TAU,
  }))
  const curtains = [
    { hue: 150, x: 0.28, amp: 28, w: 0.14, speed: 0.16 },
    { hue: 280, x: 0.42, amp: 34, w: 0.12, speed: 0.12 },
    { hue: 170, x: 0.55, amp: 26, w: 0.16, speed: 0.2 },
    { hue: 195, x: 0.68, amp: 30, w: 0.11, speed: 0.14 },
    { hue: 310, x: 0.38, amp: 22, w: 0.1, speed: 0.1 },
  ]

  return (ctx, t, w, h) => {
    ctx.clearRect(0, 0, w, h)
    const intro = clamp(t / 1.4)

    ctx.globalCompositeOperation = 'lighter'
    for (const s of stars) {
      const tw = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * 2.2 + s.o))
      ctx.fillStyle = `rgba(230,250,255,${tw * 0.55 * intro})`
      ctx.beginPath()
      ctx.arc(s.x * w, s.y * h, s.s, 0, TAU)
      ctx.fill()
    }

    for (const c of curtains) {
      ctx.beginPath()
      const steps = 56
      for (let i = 0; i <= steps; i++) {
        const v = i / steps
        const y = v * h
        const n = fbm(v * 1.8 + t * c.speed, c.hue * 0.01)
        const x = w * c.x + Math.sin(v * 2.4 + t * c.speed) * c.amp + (n - 0.5) * 40
        if (i === 0) ctx.moveTo(x, y)
        else ctx.lineTo(x, y)
      }
      for (let i = steps; i >= 0; i--) {
        const v = i / steps
        const y = v * h
        const n = fbm(v * 1.8 + t * c.speed + 2.1, c.hue * 0.01)
        const x =
          w * c.x +
          w * c.w +
          Math.sin(v * 2.4 + t * c.speed + 0.5) * c.amp * 0.7 +
          (n - 0.5) * 32
        ctx.lineTo(x, y)
      }
      ctx.closePath()
      ctx.fillStyle = `hsla(${c.hue}, 80%, 62%, ${0.07 * intro})`
      ctx.fill()
    }

    glow(ctx, w * 0.5, h * 0.32, 160, `rgba(80,255,190,${0.06 * intro})`)
    ctx.globalCompositeOperation = 'source-over'
  }
}
